import PropTypes from 'prop-types'
import Table from 'react-bootstrap/Table'
import { Link } from 'react-router-dom'
import { twoDigitMoney } from 'helpers/utils'

// AP invoices whose header names this remit address, newest first. The API
// caps the list, so the count can trail the Invoices column.
const RemitInvoices = ({ invoices }) => {
  if (invoices.length === 0) {
    return <p className="text-muted mb-0">No invoices name this remit address.</p>
  }

  return (
    <div className="w-100">
      <Table className="border border-light" size="sm" data-testid="remit-invoices-table">
        <thead className="border-bottom border-light">
          <tr>
            <th>Invoice #</th>
            <th>Invoice Date</th>
            <th className="text-end">Amount</th>
            <th>Status</th>
            <th>Check #</th>
            <th>Check Date</th>
            <th>Cleared</th>
          </tr>
        </thead>
        <tbody>
          {invoices.map((invoice) => (
            <tr key={invoice.id}>
              <td>
                <Link to={`/transactions/${invoice.id}`}>
                  {invoice.invoice_number || invoice.invoice_doc_number}
                </Link>
              </td>
              <td>{invoice.invoice_date}</td>
              <td className="text-end">{twoDigitMoney(invoice.invoice_amount)}</td>
              <td>{invoice.invoice_status_code}</td>
              <td>{invoice.check_number}</td>
              <td>{invoice.check_date}</td>
              <td>{invoice.check_clear_date}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

RemitInvoices.propTypes = {
  invoices: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      invoice_number: PropTypes.string,
      invoice_doc_number: PropTypes.string,
      invoice_date: PropTypes.string,
      invoice_amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      invoice_status_code: PropTypes.string,
      check_number: PropTypes.string,
      check_date: PropTypes.string,
      check_clear_date: PropTypes.string
    })
  ).isRequired
}

export default RemitInvoices
